import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-hourglass-full",
  templateUrl: "./med-icon-hourglass-full.component.html",
})
export class MedIconHourglassFullComponent extends SvgMixinComponent {}
